import { Modal, Button } from "react-bootstrap";

import CommonModal from "../../components/CommonModal";
import "../../components/CommonModal/manage-roster-modal.css";

/**
 * Shared confirmation shell for scheduled-training flows (Oracle Learn, Docebo, etc.).
 * Same header, footer actions, and modal chrome as manage-roster styling.
 */
const ScheduledTrainingConfirmModal = ({ show, onHide, onContinue, children }) => {
  return (
    <CommonModal
      show={show}
      onHide={onHide}
      title={<Modal.Title>Confirm Selection</Modal.Title>}
      footer={
        <>
          <Button variant="dark" onClick={onHide}>
            Close
          </Button>
          <Button variant="success" onClick={onContinue}>
            Continue
          </Button>
        </>
      }
      modalProps={{
        size: "lg",
        centered: true,
        className: "manage-roster-modal",
      }}
    >
      {children}
    </CommonModal>
  );
};

export default ScheduledTrainingConfirmModal;
